import React from "react"
import { NePasManquerTitle } from "./ne-pas-manquer-item-styled"
import {
  nePasManquerItem,
  nePasManquerItemImage,
  nePasManquerItemImg,
  nePasManquerItemTitle,
} from "../ne-pas-manquer.module.scss"
import NonStretchedImage from "gatsby-theme-blank/src/components/Image/non-stretched-image"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import PropTypes from "prop-types"

const NePasManquerItem = ({ nePasManquer }) => (
  <div className={nePasManquerItem}>
    <div className={nePasManquerItemImage}>
      <TransitionFade
        arialabel="Lien vers la page"
        link={nePasManquer.path.alias}
      >
        <NonStretchedImage
          className={nePasManquerItemImg}
          {...nePasManquer?.relationships?.field_image_page_de_base?.localFile}
        />
      </TransitionFade>
    </div>
    <NePasManquerTitle className={nePasManquerItemTitle}>
      <TransitionFade link={nePasManquer.path.alias}>
        {nePasManquer.title}
      </TransitionFade>
    </NePasManquerTitle>
  </div>
)

NePasManquerItem.propTypes = {
  nePasManquer: PropTypes.object.isRequired,
}

export default NePasManquerItem
